import { getCurrency, nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { applyMarkup, getSanitisedQuote } from '../../utils/WorkOrderUtils';
import { Button, Card, Col, Form, InputNumber, Layout, Menu, message, Row } from 'antd';
import QuotesDetailDisplay from '../quotes_detail_details_page/QuotesDetailDisplay';
import ProposalForm from '../proposal_form/ProposalForm';
import QuotePageDisplay from '../quote_page_display/QuotePageDisplay';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
	appendWorkOrderNotesForSupplier,
	workOrdersRestCrudThunksForSupplier,
} from '../../thunks/work_orders_thunks';
import { markUserNotificationsReadForSupplier } from '../../thunks/user_notifications_thunks';
import {
	createProposalSubContractor,
	proposalsRestCrudThunksForSupplier,
	updateProposalSubContractor,
} from '../../thunks/proposals_thunks';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { getQuoteSubURL, getQuoteRestCrudThunksFromPath } from '../quote_utils/QuoteUtils';
import { changeClientView } from '../../actions/client_view_actions';
import { getOtherContractorQuotes, getOtherQuotes } from '../../thunks/quotes_thunks';
import { isBuyerOrInternalTech } from '../../utils/AuthUtils';

require('./SupplierQuoteDetailDetailsPageWrapper.less');

const { Content } = Layout;

const SupplierQuoteDetailDetailsPageWrapper = ({
	quote = {},
	quotesUpdating,
	workOrder,
	showViewQuotePage,

	history,
	currentUser,
	createProposal,
	updateProposal,
	createContractorProposal,
	updateContractorProposal,
	refreshQuote,
	isClientView,
	updateClientView,
	userType,

	getOtherContractorQuotes,
	getOtherQuotes,
}) => {
	const [addingMarkup, setAddingMarkup] = useState(false);
	const [editingQuote, setEditingQuote] = useState(false);
	const [copyQuote, setCopyQuote] = useState({});
	const [contractorQuote, setContractorQuote] = useState(undefined);
	const [fetchingContractorQuote, setFetchingContractorQuote] = useState(false);
	const [loading, setLoading] = useState(false);

	const currency = getCurrency({ workOrder: workOrder });
	const { subContractedFromWorkOrder } = workOrder;

	const redirectUrl = useCallback(
		(newQuote) =>
			history.location.pathname.includes('quotes/subcontractor')
				? `/${getQuoteSubURL(userType, currentUser, newQuote)}/detail/${nullSafeGet(
						'id',
						newQuote
				  )}/details`
				: `/supplier/workOrders/detail/${nullSafeGet('workOrder.id', quote)}/client_quotes`,

		[quote, userType, currentUser]
	);

	useEffect(() => {
		if (!isBuyerOrInternalTech(currentUser) && !isClientView && !fetchingContractorQuote) {
			const params = subContractedFromWorkOrder
				? {
						contractorWorkOrderId: nullSafeGet('id', subContractedFromWorkOrder),
						contractorSupplierFacilityId: nullSafeGet(
							'contractorSupplierFacilityId',
							subContractedFromWorkOrder
						),
				  }
				: {
						workOrderId: nullSafeGet('subContractedToWorkOrder.workOrderId', workOrder),
						supplierFacilityId: nullSafeGet(
							'subContractedToWorkOrder.contractorSupplierFacilityId',
							workOrder
						),
				  };
			const fn = subContractedFromWorkOrder ? getOtherContractorQuotes : getOtherQuotes;

			setFetchingContractorQuote(true);
			fn(params).then((otherQuotes) => {
				if (nullSafeGetOrElse('length', otherQuotes, 0) > 0) {
					setContractorQuote(otherQuotes[0]);
				}
				setFetchingContractorQuote(false);
			});
		}
	}, [workOrder, isClientView, currentUser]);

	const copyCreateQuote = useCallback(() => {
		setLoading(true);
		if (subContractedFromWorkOrder) {
			const fn = contractorQuote ? updateContractorProposal : createContractorProposal;
			fn({
				...copyQuote,
				id: contractorQuote ? nullSafeGet('id', contractorQuote) : undefined,
				workOrderId: undefined,
				supplierFacilityId: undefined,
				status: 'pending',
				contractorWorkOrderId: subContractedFromWorkOrder.id,
				contractorSupplierFacilityId: subContractedFromWorkOrder.contractorSupplierFacilityId,
				subSupplierFacilityId: subContractedFromWorkOrder.subSupplierFacilityId,
			})
				.then((record) => {
					message.success('Proposal copied successfully');
					setAddingMarkup(false);
					setEditingQuote(false);
					history.push(redirectUrl(record));
				})
				.catch((err) => {
					if (err && err.startsWith('Proposal already exists for this Work order')) {
						message.error(err);
						history.goBack();
					}
				})
				.finally(() => {
					setLoading(false);
				});
		} else {
			const fn = contractorQuote ? updateProposal : createProposal;
			fn({
				...copyQuote,
				id: contractorQuote ? nullSafeGet('id', contractorQuote) : undefined,
				workOrderId: workOrder.id,
				supplierFacilityId: nullSafeGet('facility.id', currentUser),
				contractorWorkOrderId: undefined,
				contractorSupplierFacilityId: undefined,
				subSupplierFacilityId: undefined,
				status: 'pending',
			})
				.then((record) => {
					message.success('Proposal copied successfully');
					setAddingMarkup(false);
					setEditingQuote(false);
					history.push(redirectUrl(record));
				})
				.catch((err) => {
					if (err && err.startsWith('Proposal already exists for this Work')) {
						message.error(err);
					}
				})
				.finally(() => {
					setLoading(false);
				});
		}
	}, [
		subContractedFromWorkOrder,
		quote,
		createContractorProposal,
		createProposal,
		copyQuote,
		workOrder,
		currentUser,
		history,
	]);

	return (
		<Content className="SupplierQuoteDetailDetailsPageWrapper">
			{addingMarkup ? (
				<>
					<div className=" flex flex-row justify-end">
						<Button style={{ marginRight: 12 }} onClick={() => setAddingMarkup(false)}>
							Cancel
						</Button>
					</div>

					<Row gutter={12} style={{ margin: '16px 8px ' }}>
						<Col span={12}>
							<Card>
								<div className=" flex w-full flex-row items-baseline justify-between">
									<h5>Subcontractor Quote</h5>
								</div>
								<QuotesDetailDisplay currency={currency} quote={quote} />
							</Card>
						</Col>
						<Col span={12}>
							<Card>
								<div className=" flex w-full flex-row items-baseline justify-between">
									<h5>Your Quote</h5>
									<div>
										<Form.Item style={{ marginBottom: 0 }} label="Add Markup">
											<InputNumber
												value={quote.markup}
												addonBefore="+"
												addonAfter="%"
												onChange={(value) => {
													setCopyQuote({
														...copyQuote,
														...applyMarkup(quote, value),
													});
												}}
											/>
										</Form.Item>
									</div>
								</div>
								<QuotesDetailDisplay currency={currency} quote={copyQuote} />
								<div className="flex flex-row justify-end">
									<Button
										loading={loading}
										type="primary"
										className="mt-4"
										onClick={copyCreateQuote}
									>
										{contractorQuote ? 'Update' : 'Create'} Quote
									</Button>
								</div>
							</Card>
						</Col>
					</Row>
				</>
			) : editingQuote ? (
				<>
					<div className=" mr-4 flex flex-row justify-end">
						<Button style={{ marginRight: 12 }} onClick={() => setEditingQuote(false)}>
							Cancel
						</Button>
					</div>
					<Row gutter={12} style={{ margin: '16px 8px ' }}>
						<Card style={{ margin: '16px' }}>
							<ProposalForm
								workOrder={workOrder}
								formData={{
									...copyQuote,
									id: contractorQuote ? contractorQuote.id : undefined,
									workOrderId: workOrder.id,
								}}
								onSuccess={(record) => {
									message.success('Proposal copied successfully');
									history.push(redirectUrl(record));
								}}
								copyMode
							/>
						</Card>
					</Row>
				</>
			) : (
				<>
					<QuotePageDisplay
						key={quote.id}
						quote={getSanitisedQuote(quote, isClientView)}
						refreshQuote={refreshQuote}
						showViewQuotePage={showViewQuotePage}
						quotesUpdating={quotesUpdating}
						workOrder={workOrder}
						setAddingMarkup={setAddingMarkup}
						setEditingQuote={setEditingQuote}
						setCopyQuote={setCopyQuote}
						isClientView={isClientView}
						otherQuote={contractorQuote}
						displayComparison={true}
					/>
				</>
			)}
		</Content>
	);
};

const mapStateToProps = (state, ownProps) => ({
	currentUser: state.session.currentUser,
	match: ownProps.match,
	history: ownProps.history,
	location: ownProps.location,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	appendWorkOrderNotes: (entity) => dispatch(appendWorkOrderNotesForSupplier(entity)),
	getWorkOrder: (id) => dispatch(workOrdersRestCrudThunksForSupplier.readOne(id)),
	markUserNotificationsRead: (entityId) =>
		dispatch(markUserNotificationsReadForSupplier('Quote', entityId)),
	createContractorProposal: (proposal) => dispatch(createProposalSubContractor(proposal)),
	updateContractorProposal: (proposal) => dispatch(updateProposalSubContractor(proposal)),
	createProposal: (proposal) => dispatch(proposalsRestCrudThunksForSupplier.create(proposal)),
	updateProposal: (proposal) => dispatch(proposalsRestCrudThunksForSupplier.update(proposal)),
	updateClientView: (isClientView) => dispatch(changeClientView(isClientView)),
	getQuote: (id) =>
		dispatch(getQuoteRestCrudThunksFromPath(ownProps.userType, ownProps.location).readOne(id)),
	getOtherContractorQuotes: (params, targetCollectionName) =>
		dispatch(getOtherContractorQuotes(params, targetCollectionName)),
	getOtherQuotes: (params, targetCollectionName) =>
		dispatch(getOtherQuotes(params, targetCollectionName)),
});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(SupplierQuoteDetailDetailsPageWrapper)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
		currentUser: (state as any).session.currentUser,
	}),
	() => ({})
)(ComponentWithoutUserType);
